import { Divider, Drawer } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom"; // <-- agrega useLocation

// Estilos para el Drawer Header
const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "center",
}));

const NavbarContent = styled("div")({
    overflowY: "auto",
    height: "calc(100vh - 64px)",
    "&::-webkit-scrollbar": {
        width: "0px",
        background: "transparent",
    },
    msOverflowStyle: "none",
    scrollbarWidth: "none",
});

export const NavBar = ({ sidebarVisible, sidebarStatus, closeSidebar }) => {
    const className = sidebarVisible ? (sidebarStatus === "mobile-active" ? "pc-sidebar pc-trigger mob-sidebar-active" : "pc-sidebar pc-trigger") : "pc-sidebar pc-sidebar-hide";
    const { name_admin, rol_admin } = useSelector((state) => state.auth);

    const location = useLocation(); // <-- hook para obtener la ruta actual

    // Función para saber si la ruta está activa
    const isActive = (path) => location.pathname.startsWith(path);

    const [agendaOpen, setAgendaOpen] = useState(false);

    // Abrir el submenú si alguna ruta hija está activa
    useEffect(() => {
        if (isActive("/agenda/vendedoras") || isActive("/agenda/personal")) {
            setAgendaOpen(true);
        }
    }, [location.pathname]);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            const nav = document.querySelector(".pc-sidebar");
            if (nav && !nav.contains(event.target) && sidebarVisible && (sidebarStatus === "mobile-active" || window.innerWidth <= 1024)) {
                closeSidebar();
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [sidebarVisible, sidebarStatus, closeSidebar]);

    return (
        <>
            <Drawer
                variant="persistent"
                anchor="left"
                open={sidebarVisible}
                onClose={closeSidebar}
                className={className}
                PaperProps={{ className: className }}
            >
                <DrawerHeader>
                    <a href="" className="b-brand text-dark" style={{ display: "flex", alignItems: "center" }}>
                        <img src="/logo.png" style={{ width: "90px", height: "80px", marginRight: "10px" }} alt="StudioCinemas" className="logo-lg" />
                        <img src="/assets/logo2.jpg" style={{ width: "145px", height: "50px" }} alt="StudioCinemas" className="logo-lg" />
                    </a>
                </DrawerHeader>

                <Divider />
                <NavbarContent>
                    <ul className="pc-navbar" style={{ display: "block" }}>
                        <li className="pc-item pc-caption">
                            <label>Menú Principal</label>
                        </li>

                        <li className="pc-item">
                            <NavLink to="/" className="pc-link active">
                                <span className="pc-micon">
                                    <i className="ti ti-home"></i>
                                </span>
                                <span className="pc-mtext">Inicio</span>
                            </NavLink>
                        </li>

                        {/* <li className="pc-item">
                            <NavLink to="/Movies/list" className="pc-link active">
                                <span className="pc-micon">
                                    <i className="ti ti-search"></i>
                                </span>
                                <span className="pc-mtext">Buscador General</span>
                            </NavLink>
                        </li> */}

                        <li className="pc-item pc-caption">
                            <label>Modulos</label>
                        </li>
                        {/* Otras opciones de menú */}
                        <li className={`pc-item${isActive("/clientes") ? " active" : ""}`}>
                            <NavLink to="/clientes/lista" className="pc-link">
                                <span className="pc-micon">
                                    <i className="ti ti-users"></i>
                                </span>
                                <span className="pc-mtext">Clientes</span>
                            </NavLink>
                        </li>
                        <li className={`pc-item${isActive("/calendario/ver") ? " active" : ""}`}>
                            <NavLink to="/calendario/ver" className="pc-link">
                                <span className="pc-micon">
                                    <i className="ti ti-calendar"></i>
                                </span>
                                <span className="pc-mtext">Calendario Salones</span>
                            </NavLink>
                        </li>
                        <li className={`pc-item${isActive("/calendario/lista") ? " active" : ""}`}>
                            <NavLink to="/calendario/lista" className="pc-link">
                                <span className="pc-micon">
                                    <i className="ti ti-calendar-time"></i>
                                </span>
                                <span className="pc-mtext">Eventos Salones</span>
                            </NavLink>
                        </li>
                        <li className={`pc-item${isActive("/articulos") ? " active" : ""}`}>
                            <NavLink to="/articulos/lista" className="pc-link">
                                <span className="pc-micon">
                                    <i className="ti ti-basket"></i>
                                </span>
                                <span className="pc-mtext">Articulos</span>
                            </NavLink>
                        </li>
                        <li className={`pc-item${isActive("/cotizaciones") ? " active" : ""}`}>
                            <NavLink to="/cotizaciones/lista" className="pc-link">
                                <span className="pc-micon">
                                    <i className="ti ti-certificate"></i>
                                </span>
                                <span className="pc-mtext">Cotizaciones</span>
                            </NavLink>
                        </li>
                        <li className={`pc-item${isActive("/contratos") ? " active" : ""}`}>
                            <NavLink to="/contratos/lista" className="pc-link">
                                <span className="pc-micon">
                                    <i className="ti ti-chart-arrows-vertical"></i>
                                </span>
                                <span className="pc-mtext">Contratos</span>
                            </NavLink>
                        </li>
                        <li className={`pc-item${isActive("/reportes") ? " active" : ""}`}>
                            <NavLink to="/agenda/reporte" className="pc-link">
                                <span className="pc-micon">
                                    <i className="ti ti-tag"></i>
                                </span>
                                <span className="pc-mtext">Reportes Agenda</span>
                            </NavLink>
                        </li>
                        {
                            rol_admin === 1 ? (
                                // Menú con submenú para administradores
                                <li className={`pc-item${isActive("/agenda") ? " active" : ""}${agendaOpen ? " open" : ""}`}>
                                    <a
                                        href="#"
                                        className="pc-link"
                                        onClick={e => {
                                            e.preventDefault();
                                            setAgendaOpen(!agendaOpen);
                                        }}
                                    >
                                        <span className="pc-micon">
                                            <i className="ti ti-calendar-time"></i>
                                        </span>
                                        <span className="pc-mtext">Agenda</span>
                                        <span className="pc-arrow"><i className="ti ti-chevron-down"></i></span>
                                    </a>
                                    <ul className="pc-submenu" style={{ display: agendaOpen ? "block" : "none" }}>
                                        <li className={isActive("/agenda/vendedoras") ? "active" : ""}>
                                            <NavLink to="/agenda/vendedoras" className="pc-link">
                                                <span className="pc-mtext">Agenda Vendedoras</span>
                                            </NavLink>
                                        </li>
                                        <li className={isActive("/agenda/personal") ? "active" : ""}>
                                            <NavLink to="/agenda/personal" className="pc-link">
                                                <span className="pc-mtext">Mi Agenda</span>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                            ) : (
                                // Menú simple para otros roles
                                <li className={`pc-item${isActive("/agenda") ? " active" : ""}`}>
                                    <NavLink to="/agenda/personal" className="pc-link">
                                        <span className="pc-micon">
                                            <i className="ti ti-calendar-time"></i>
                                        </span>
                                        <span className="pc-mtext">Mi Agenda</span>
                                    </NavLink>
                                </li>
                            )
                        }
                        <li className={`pc-item${isActive("/reportes") ? " active" : ""}`}>
                            <NavLink to="/reportes/eventos" className="pc-link">
                                <span className="pc-micon">
                                    <i className="ti ti-report-money"></i>
                                </span>
                                <span className="pc-mtext">Reportes Eventos</span>
                            </NavLink>
                        </li>
                    </ul>

                    <div className="card pc-user-card">
                        <div className="card-body">
                            <div className="d-flex align-items-center">
                                <div className="avtar avtar-s btn-light-dark">
                                    <i className="ph-duotone ph-buildings f-22"></i>
                                </div>
                                <div className="flex-grow-1 ms-3 me-2">
                                    <h6 className="mb-0">{name_admin}</h6>
                                    <small>Administrator</small>
                                </div>
                                <div className="dropdown">
                                    <a
                                        href="#"
                                        className="btn btn-icon btn-link-secondary avtar arrow-none dropdown-toggle"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        data-bs-offset="0,20"
                                    >
                                        <i className="ph-duotone ph-windows-logo"></i>
                                    </a>
                                    <div className="dropdown-menu">
                                        <ul>
                                            <li>
                                                <NavLink to="/admins/cambioContrasena" className="pc-user-links">
                                                    <i className="ph-duotone ph-password"></i>
                                                    <span>Cambio Clave</span>
                                                </NavLink>
                                            </li>
                                            {rol_admin === 1 && (
                                                <li>
                                                    <NavLink to="/admins/lista" className="pc-user-links">
                                                        <i className="ph-duotone ph-users"></i>
                                                        <span>Lista usuarios</span>
                                                    </NavLink>
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </NavbarContent>
            </Drawer>
        </>
    );
};
